import { Identifiable, CalendarHolidays } from "@planzone/dto";
import { Filter } from "@planzone/dto";

function isFilteredByResources(
  { uuid }: Identifiable<CalendarHolidays>,
  { resources }: Filter,
) {
  return (
    !!resources &&
    resources.length > 0 &&
    !resources.find((resource) => resource.calendarHolidays?.uuid === uuid)
  );
}

export { isFilteredByResources };
